import { ReactNode, useEffect, useState } from 'react';
import { ChevronsLeft, MenuIcon } from 'lucide-react';
import { useMediaQuery } from 'usehooks-ts';
import { cn } from '@/lib/utils';
import { useLocation } from 'react-router-dom';

const SidebarWrapper = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(!isMobile);

  // Close sidebar on mobile and route changes
  useEffect(() => {
    if (isMobile) {
      setIsOpen(false);
    }
  }, [isMobile, location.pathname]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={toggleSidebar}
        className={cn(
          'fixed top-4 z-[101] h-6 w-6 text-muted-foreground',
          isOpen ? 'hidden' : 'left-4'
        )}
      >
        <MenuIcon className="h-6 w-6" />
      </button>

      {/* Backdrop */}
      {isMobile && isOpen && (
        <div className="fixed inset-0 bg-black/20 z-[99]" onClick={closeSidebar} />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed md:relative z-[100] h-full bg-secondary border-r',
          'flex flex-col overflow-hidden transition-all duration-300',
          isOpen ? 'w-[280px]' : 'w-0',
          isMobile ? 'left-0' : ''
        )}
      >
        {/* Close Button */}
        <button
          onClick={closeSidebar}
          className={cn(
            'absolute right-2 top-3 h-6 w-6 mt-1 rounded-sm',
            'text-muted-foreground hover:bg-accent transition-opacity'
          )}
        >
          <ChevronsLeft className="h-6 w-6" />
        </button>

        {/* Content */}
        <div className="min-w-[235px]">{children}</div>
      </aside>
    </>
  );
};

export default SidebarWrapper;
